export default __webpack_public_path__ + "static/media/inputOrangeCircle.6a04014c.svg";